import { NavLink, useParams } from 'react-router-dom';
import { MainHeader } from '.';
import { useEffect, useState } from 'react';
import { useTree } from '../../../Context/useTree';

let MenuSubCatigory = () => {

    const { location, menuId, submenuId } = useParams();
    const { treeData, fetchTree, findMenuById, findSubmenuById } = useTree();
    const [subMenuCatigories, setSubMenuCatigories] = useState([]);

    useEffect(() => {
        fetchTree(location)
            .then(() => {
                // Data will be available from context
                if (submenuId) {
                    // Get direct submenu - either its children or items
                    const submenu = findSubmenuById(submenuId);
                    if (submenu) {
                        // If submenu has children, show children; otherwise show items
                        const content = submenu.hasChildren ? submenu.children : submenu.items;
                        setSubMenuCatigories(content || []);
                    }
                } else {
                    // Get all submenus of this menu
                    const menu = findMenuById(menuId);
                    if (menu) {
                        setSubMenuCatigories(menu.submenus || []);
                    }
                }
            })
            .catch((error) => {
                console.error("Error loading tree data:", error);
            });
    }, [location, menuId, submenuId, fetchTree, findMenuById, findSubmenuById])

    const getSubmenuOptions = () => {
        return subMenuCatigories.map((item) => {
            console.log(item);

            // Check if this is a submenu item (has submenuId) or a menu item (has menuItemId)
            if (item.submenuId !== undefined) {
                // This is a submenu

                // Check if this submenu has a cart action
                if (item.submenuActionTargetGUID) {
                    return (
                        <div className="menu-subcatigory-wrapper" key={item.submenuId}>
                            {item.submenuButtonImageUrl ?
                                <NavLink className='nav-link' to={`/v2/${location}/CartRequest`}>
                                    <img className="menu-catigory-images"
                                        src={item.submenuButtonImageUrl}
                                        alt="page text" />
                                </NavLink>
                                :
                                <div className="menu-catigory-placeholder">
                                    <NavLink className='nav-link' to={`/v2/${location}/CartRequest`}>
                                        <h2 className="menu-catigory-placeholder-text">{item.submenuText}</h2>
                                    </NavLink>
                                </div>
                            }
                        </div>
                    );
                }

                // Check if submenu has children (drill down further)
                if (item.hasChildren) {
                    return (
                        <div className="menu-subcatigory-wrapper" key={item.submenuId}>
                            {item.submenuButtonImageUrl ?
                                <NavLink className='nav-link' to={`/v2/${location}/${menuId}/${item.submenuId}`}>
                                    <img className="menu-catigory-images"
                                        src={item.submenuButtonImageUrl}
                                        alt="page text" />
                                </NavLink>
                                :
                                <div className="menu-catigory-placeholder">
                                    <NavLink className='nav-link' to={`/v2/${location}/${menuId}/${item.submenuId}`}>
                                        <h2 className="menu-catigory-placeholder-text">{item.submenuText}</h2>
                                    </NavLink>
                                </div>
                            }
                        </div>
                    );
                }

                // Submenu has items (no children)
                return (
                    <div className="menu-subcatigory-wrapper" key={item.submenuId}>
                        {item.submenuButtonImageUrl ?
                            <NavLink className='nav-link' to={`/v2/${location}/${menuId}/${item.submenuId}/items`}>
                                <img className="menu-catigory-images"
                                    src={item.submenuButtonImageUrl}
                                    alt="page text" />
                            </NavLink>
                            :
                            <div className="menu-catigory-placeholder">
                                <NavLink className='nav-link' to={`/v2/${location}/${menuId}/${item.submenuId}/items`}>
                                    <h2 className="menu-catigory-placeholder-text">{item.submenuText}</h2>
                                </NavLink>
                            </div>
                        }
                    </div>
                );
            } else if (item.menuItemId !== undefined) {
                // This is a menu item
                return (
                    <div className="menu-subcatigory-wrapper" key={item.menuItemId}>
                        {item.itemImageUrl ?
                            <NavLink className='nav-link' to={`/v2/${location}/${menuId}/${item.menuItemId}`}>
                                <img className="menu-catigory-images"
                                    src={item.itemImageUrl}
                                    alt="page text" />
                            </NavLink>
                            :
                            <div className="menu-catigory-placeholder">
                                <NavLink className='nav-link' to={`/v2/${location}/${menuId}/${item.menuItemId}`}>
                                    <h2 className="menu-catigory-placeholder-text">{item.itemName}</h2>
                                </NavLink>
                            </div>
                        }
                    </div>
                );
            }
        });
    }

    return (
        <div>
            <MainHeader />
            <div className="body">
                {getSubmenuOptions()}
            </div>
        </div>
    );
}

export default MenuSubCatigory;
